import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const BackButton = () => {
  const navigate = useNavigate()
  const location = useLocation()

  if (location.pathname === '/') {
    return null
  }

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }

    navigate('/')
  }

  return (
    <button
      type="button"
      className="btn btn-outline-primary back-button"
      onClick={handleBack}
    >
      Back
    </button>
  )
}

export default BackButton
